/* eslint-disable eslint-compat/camelcase */
export type Ga4Session = { client_id: string; session_id: string };

// Stay below the frontend's 500 ms navigation delay. Blocked/misconfigured Google tags must not hold up Segment events.
const GA4_SESSION_TIMEOUT_MS = 200;

export const getGa4Session = (measurementId: string): Promise<Partial<Ga4Session>> => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function' || !/^G-[A-Z0-9]+$/.test(measurementId)) {
    return Promise.resolve({});
  }

  return new Promise(resolve => {
    let clientId: string | undefined;
    let sessionId: string | undefined;
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      // Never invent identifiers or send a partial pair that could create a different session.
      resolve(clientId && sessionId ? { client_id: clientId, session_id: sessionId } : {});
    };
    const timeout = setTimeout(finish, GA4_SESSION_TIMEOUT_MS);
    const receive = (field: 'client_id' | 'session_id', value: unknown) => {
      if (settled) return;
      const identifier = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
      if (!identifier || (field === 'session_id' && !/^[1-9]\d*$/.test(identifier))) {
        finish();
        return;
      }
      if (field === 'client_id') clientId = identifier;
      else sessionId = identifier;
      if (clientId && sessionId) finish();
    };

    try {
      window.gtag('get', measurementId, 'client_id', (value: unknown) => receive('client_id', value));
      window.gtag('get', measurementId, 'session_id', (value: unknown) => receive('session_id', value));
    } catch {
      finish();
    }
  });
};
